import { render } from "./SetDAAFrequencies.vue?vue&type=template&id=e8fc7b60"
import script from "./SetDAAFrequencies.vue?vue&type=script&lang=js"
export * from "./SetDAAFrequencies.vue?vue&type=script&lang=js"

import "./SetDAAFrequencies.vue?vue&type=style&index=0&id=e8fc7b60&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__